import React, { useEffect, useState } from 'react'
import { useFormState } from 'react-hook-form'
import { Typography, InputAdornment, MenuItem } from '@mui/material'
import PropTypes from 'prop-types'

import Input from 'components/generic/form/Input'

const EditableCellTypes = {
  TEXT: 'TEXT',
  CURRENCY: 'CURRENCY',
  SELECT: 'SELECT',
}

const EditableCell = ({
  cellType,
  isEdit,
  onChange,
  getError,
  showErrorsBeforeSubmit,
  startAdornment,
  removeTrailingZeros,
  ...props
}) => {
  const { name, defaultValue, control, options, fontSize } = props
  const state = useFormState({ control, name })
  const showErrors = showErrorsBeforeSubmit || state.isSubmitted
  const [value, setValue] = useState(defaultValue)
  const error = getError(value)

  useEffect(() => {
    if (removeTrailingZeros) {
      setValue(+parseFloat(value))
    }
  }, [value])

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  if (!isEdit) {
    return (
      <Typography sx={{ fontSize }}>
        {cellType === EditableCellTypes.CURRENCY ? '$' : ''}
        {cellType === 'SELECT' ? value.toUpperCase() : value}
      </Typography>
    )
  }

  const standardProps = {
    onChange: event => {
      setValue(event.target.value)
      if (onChange instanceof Function) onChange(event)
    },
  }
  switch (cellType) {
    case EditableCellTypes.CURRENCY:
      standardProps.InputProps = {
        startAdornment: <InputAdornment position="end">$</InputAdornment>,
        inputProps: { style: { textAlign: 'right' } },
      }
      break
    case EditableCellTypes.SELECT:
      standardProps.select = true
      standardProps.children = options?.map(opt => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))
      break
    case EditableCellTypes.TEXT: // same as default
    default:
  }
  return <Input {...standardProps} {...props} error={showErrors && !!error} value={value} />
}

EditableCell.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  isEdit: PropTypes.bool,
  control: PropTypes.object.isRequired,
  getError: PropTypes.func,
  cellType: PropTypes.oneOf(Object.keys(EditableCellTypes)),
  options: PropTypes.array,
  defaultValue: PropTypes.any,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  fontSize: PropTypes.string,
  showErrorsBeforeSubmit: PropTypes.bool,
  startAdornment: PropTypes.node,
  removeTrailingZeros: PropTypes.bool,
}

EditableCell.defaultProps = {
  value: undefined,
  isEdit: false,
  getError: () => undefined,
  cellType: EditableCellTypes.TEXT,
  options: undefined,
  defaultValue: '',
  fontSize: '0.875rem',
  required: false,
  showErrorsBeforeSubmit: false,
  startAdornment: undefined,
  onChange: () => undefined,
  removeTrailingZeros: false,
}

export default EditableCell
